export default {
  slug: "dotultimate",
  code: "DU",
  label: "dotUltimate",
  shortLabel: "dotUltimate",
  altLabel: "dotUltimate",
  isDotNet: true,
  logoFamily: "jb",
};
